import {
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  useControllableProp,
  useFormControlContext,
} from '@chakra-ui/react';
import * as React from 'react';

import { SelectButton } from '@/components/SelectButton';

export const SingleSelect = React.forwardRef<
  HTMLButtonElement,
  {
    attribute: { options: { id: string; label: string }[] };
    value: string | null;
    onChange: (value: string) => void;
    onBlur?: () => void;
    isDisabled?: boolean;
    autoFocus?: boolean;
  }
>((props, ref) => {
  const labels = props.attribute.options.reduce<Record<string, string>>(
    (prev, curr) => ({ ...prev, [curr.id]: curr.label }),
    {}
  );

  const formControlContext = useFormControlContext();

  const [, isDisabled] = useControllableProp(
    props.isDisabled ? true : undefined,
    formControlContext?.isDisabled
  );

  return (
    <Menu matchWidth defaultIsOpen={props.autoFocus === true}>
      <MenuButton
        as={SelectButton}
        ref={ref}
        isDisabled={isDisabled}
        autoFocus={props.autoFocus}
      >
        {props.value ? labels[props.value] : ''}
      </MenuButton>
      <MenuList>
        <MenuOptionGroup
          type="radio"
          value={props.value ?? undefined}
          onChange={props.onChange}
        >
          {props.attribute.options.map((option) => (
            <MenuItemOption key={option.id} value={option.id}>
              {option.label}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
});

SingleSelect.displayName = 'SingleSelect';
